import React from 'react';
import { sanitizeHtml } from '../utils/sanitizeHtml';

const SIZE_CLASSES = {
  sm: 'prose-sm',
  base: 'prose-base',
  lg: 'prose-lg',
};

const VARIANT_CLASSES = {
  editorial: [
    'prose prose-slate dark:prose-invert max-w-none',
    'prose-headings:font-bold prose-headings:tracking-tight',
    'prose-h2:text-2xl sm:prose-h2:text-3xl prose-h2:mt-0 prose-h2:mb-3',
    'prose-h3:text-xl prose-h3:mt-6 prose-h3:mb-2',
    'prose-p:leading-relaxed',
    'prose-a:font-semibold prose-a:text-blue-700 hover:prose-a:text-blue-800',
    'dark:prose-a:text-blue-300 dark:hover:prose-a:text-blue-200',
    'prose-img:rounded-xl prose-img:shadow-sm',
  ].join(' '),
  banner: [
    'prose dark:prose-invert max-w-none',
    'prose-headings:text-current prose-p:text-current prose-strong:text-current prose-li:text-current',
    'prose-a:text-current prose-a:underline prose-a:font-semibold',
    'prose-h2:my-1 prose-h3:my-1 prose-p:my-1 prose-ul:my-2 prose-ol:my-2',
    'prose-img:mx-auto prose-img:rounded-xl',
  ].join(' '),
};

export default function RichContentRenderer({
  html,
  className = '',
  variant = 'editorial',
  size = 'base',
  centered = false,
  inline = false,
}) {
  const safeHtml = sanitizeHtml(html);
  if (!hasVisibleContent(safeHtml)) return null;

  if (inline) {
    return (
      <span
        className={className}
        dangerouslySetInnerHTML={{ __html: safeHtml }}
      />
    );
  }

  const classes = [
    VARIANT_CLASSES[variant] || VARIANT_CLASSES.editorial,
    SIZE_CLASSES[size] || SIZE_CLASSES.base,
    centered ? 'mx-auto text-center' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
}

function hasVisibleContent(html) {
  return /<(img|br)\b/i.test(html) || String(html || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0;
}
